/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Bill: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M512.505856 454.90176l0.218112 0.218112a28.96896 28.96896 0 0 0-0.43008-0.007168l0.211968-0.210944z m0-1.010688l-39.72096-39.72096c-11.109376-11.108352-29.118464-11.108352-40.226816 0-11.108352 11.108352-11.108352 29.118464 0 40.225792l29.1584 29.159424h-20.82816c-15.70816 0-28.443648 12.735488-28.443648 28.444672s12.734464 28.444672 28.444672 28.444672h42.665984v28.444672h-42.665984c-15.710208 0-28.444672 12.734464-28.444672 28.443648 0 15.710208 12.734464 28.444672 28.444672 28.444672h42.665984v28.444672c0 15.709184 12.735488 28.444672 28.444672 28.444672s28.444672-12.735488 28.444672-28.444672V625.77664h42.665984c15.710208 0 28.444672-12.734464 28.444672-28.444672 0-15.70816-12.734464-28.443648-28.444672-28.443648h-42.665984v-28.444672h42.665984c15.710208 0 28.444672-12.735488 28.444672-28.444672s-12.734464-28.444672-28.444672-28.444672h-19.816448l29.1584-29.159424c11.108352-11.107328 11.108352-29.11744 0-40.225792-11.107328-11.108352-29.11744-11.108352-40.225792 0l-39.72096 39.72096z m27.9296 28.940288l0.723968 0.723968h-0.714752c0-0.241664-0.003072-0.483328-0.009216-0.723968zM341.332992 113.777664v56.889344c0 31.418368 25.469952 56.88832 56.889344 56.88832H625.77664c31.419392 0 56.889344-25.469952 56.889344-56.88832V113.77664h113.77664c31.419392 0 56.889344 25.469952 56.889344 56.889344v739.555328c0 31.418368-25.469952 56.88832-56.88832 56.88832H227.555328c-31.418368 0-56.88832-25.469952-56.88832-56.88832V170.667008c0-31.419392 25.469952-56.889344 56.88832-56.889344h113.777664z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M426.667008 113.777664h170.665984c15.710208 0 28.444672 12.735488 28.444672 28.444672s-12.734464 28.444672-28.444672 28.444672H426.667008c-15.710208 0-28.444672-12.735488-28.444672-28.444672s12.734464-28.444672 28.444672-28.444672z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </Svg>
  );
};

Bill.defaultProps = {
  size: 18,
};

Bill = React.memo ? React.memo(Bill) : Bill;

export default Bill;
